import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Field = styled.div`
  margin-bottom: 25px;
  text-align: left;
`;

export const Box = styled.div`
  padding: 0 32px;
  height: calc(100vh - 180px);
  overflow: auto;
  border-radius: 16px;
  max-width: 424px;
  text-align: center;
  margin: 0 auto;
`;

export const InputBox = styled.div`
  display: flex;
  align-items: center;
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
  * {
    font-size: 12px;
  }
`;

export const InputLabel = styled.label`
  text-align: right;
  margin-right: 12px;
  font-size: 12px;
  flex: 1;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const InputArea = styled.div`
  flex: 1;
  position: relative;
`;

export const PageTitle = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const PageHeader = styled.div`
  margin: 34px auto 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Initial = styled.div`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  background: linear-gradient(139.04deg, #6a92e9 15.28%, #84a5ed 44.81%, #a8bff2 84.37%);
  color: #fff;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  border: 2px solid #fff;
`;

export const Footer = styled.div`
  align-items: center;
  justify-content: center;
  margin-top: 48px;
  button {
    margin: 5px;
    padding: 0 25px;
    height: 32px;
    display: inline;
  }
`;

export const GoBackLink = styled(Link)`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 10px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
`;
